import { withNamespaces } from '@/i18n/route-namespaces'

export const n8nRoutes = {
  path: 'n8n',
  lazy: withNamespaces(['bots'], async () => {
    const { N8nPage } = await import('@/pages/n8n')

    return { Component: N8nPage }
  }),
}
